import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserCommonService } from 'app/modules/shared/services/user-common.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { SidebarService } from 'app/modules/shared/services/sidebar.service';
import { NotificationsService } from 'app/modules/shared/services/notifications.service';
import { environment } from 'environments/environment';


@Component({
    selector: 'app-shibboleth-sign-in',
    templateUrl: './shibboleth-sign-in.component.html',
    standalone: false
})
export class ShibbolethSignInComponent implements OnInit {
  testVariable = "Hello";
  shibbolethToken;
  signInResponse;
  user: any;
  shibbolethLogoutUrl: string;
  signInWelcomeTextLabel: any;
  signInDescription: any;
  message = ' ';
  constructor(private activateRouter: ActivatedRoute,
    private userCommonService: UserCommonService,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private uiService: UiService,
    private sidebarService: SidebarService,
    private notificationService: NotificationsService,
    private router: Router) { }

  ngOnInit() {
    this.signInWelcomeTextLabel = this.commonBindingDataService.getLabel('label_sign_in_welcome_text');
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    // this.shibbolethLogoutUrl = environment.logoutUrl;
    this.shibbolethToken = this.activateRouter.snapshot.queryParams.a;
    if (this.shibbolethToken !== undefined) {
      this.message = '';
      this.signInApiCall();
    }
  }

  redirectToDashboard() {
    this.uiService.profileUpdated();
    this.router.navigate(['/bus-dashboard']);
  }

  signInApiCall() {
    const signInData = {
      referenceToken: this.shibbolethToken,
      deviceDetails: {}
    };

    this.userCommonService.shibbolethSign(signInData).subscribe(signInResult => {
      this.setSessionAndUserDetails(signInResult);
      this.signInResponse = signInResult;
      this.notificationService.canFetchNotification = true;
    }, error => {
      this.message = error.general[0].message;
    });

  }

  setSessionAndUserDetails(results) {
    this.storageService.setItemInCookies(AppSettings.TOKEN_KEY, results.sessionToken);
    // this.storageService.setItem(AppSettings.TOKEN_KEY, results.sessionToken);
    this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
    AppSettings.HEADER_AUTHORIZATION_VALUE = results.sessionToken;
    AppSettings.USER = results.user;
    this.storageService.setItem(AppSettings.ACCESS_MENU, results.accessGroup);
    this.getTimeSetting();
  }

  getTimeSetting() {
    this.commonBindingDataService.getTiming().subscribe(timeSets => {
      this.storageService.setItem(AppSettings.TIME_SETTINGS, timeSets);
      this.setRoles();
      this.uiService.profileUpdated();
      this.router.navigate(['/bus-dashboard']);
    });
  }


  setRoles() {
    this.makeListOfMenuByRole();
    this.uiService.profileUpdated();
    this.sidebarService.getDispatcherMenu();
    AppSettings.roles.forEach(element => {
      if (element.roleCode === this.signInResponse.user.roles[0].roleCode) {
        AppSettings.LOGGED_IN_ROLE = this.signInResponse.user.roles[0].roleCode;
        this.uiService.profileUpdated();
        this.sidebarService.getDispatcherMenu();
      }
    });
  }


  makeListOfMenuByRole() {
    let accessGroupNames = [];
    accessGroupNames = this.signInResponse.accessGroup;
    accessGroupNames = this.uniqArray(accessGroupNames);
    this.storageService.setItem(AppSettings.ACCESS_MENU, accessGroupNames);
  }

  uniqArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  onLogin() {
    // window.location.href = environment.loginUrl;
  }
}
